import React from 'react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { signInWithGoogle } from './services/authService';

interface SocialSignInProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const SocialSignIn = ({ loading, setLoading }: SocialSignInProps) => {
  const { toast } = useToast();

  const handleSignInWithGoogle = async () => {
    try {
      setLoading(true);
      // Get the current domain for proper redirection
      const redirectUrl = window.location.origin + '/auth/callback';
      
      const { error } = await signInWithGoogle(redirectUrl);
      if (error) throw error;
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white px-2 text-gray-500">Or continue with</span>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={handleSignInWithGoogle}
        className="w-full"
        disabled={loading}
      >
        <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
          />
        </svg>
        {loading ? 'Please wait...' : 'Sign up with Google'}
      </Button>
    </>
  );
};
